import React, { useState, useEffect } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { listParams } from "../../services/pageOne";

const SelectAsyncPuntajeSisben = (props) => {
    const [defaultValue, setDefaultValue] = useState(null);

    useEffect(() => {
        const fetchDefaultValue = async () => {
            if (props.id) {
                const response = await listParams(20);
                const value = response.results.find(
                    (item) => item.id === props.id
                );
                setDefaultValue(value);
                if (value) {
                    props.onChange(value);
                }
            }
        };

        fetchDefaultValue();
    }, [props.id, props.onChange]);

    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        try {
            const pageSize = 20;
            const response = await listParams(pageSize, page);
            
            return {
                options: response.results,
                hasMore: response.next !== null,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            console.error("Error fetching options:", error);
            return {
                options: [],
                hasMore: false,
            };
        }
    };

    const onChange = (option) => {
        if (typeof props.onChange === "function") {
            props.onChange(option);
        }
    };

    return (
        <AsyncPaginate
            styles={props.styles}
            key={(option) => option.id}
            value={props.value || defaultValue || ""}
            loadOptions={loadOptions}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.detalle}
            onChange={onChange}
            placeholder="Seleccionar"
            additional={{
                page: 1,
            }}
            isSearchable
            filterOption={(option, inputValue) =>
                option.label.toLowerCase().includes(inputValue.toLowerCase())
            }
        />
    );
};

export default SelectAsyncPuntajeSisben;